/** @jsxImportSource @emotion/react */
import { Theme, Typography, TypographyProps, useTheme } from '@mui/material';
import React, { ReactNode } from 'react';
import { StylesClassName, UseStyles } from 'types/styles';

interface HeadingProps extends Omit<TypographyProps, 'className'> {
  className?: StylesClassName;
  component?: string;
  children?: ReactNode;
}

const Heading: React.FC<HeadingProps> = ({ className, children, ...rest }) => {
  const theme = useTheme() as Theme;
  const classes = useStyles(theme);

  return (
    <Typography
      css={[classes.Heading, className]}
      mb={9}
      pl={2}
      variant="h5"
      color={theme.palette.custom.primary.brand[120]}
      component="h1"
      {...rest}
    >
      {children}
    </Typography>
  );
};

const useStyles = (theme: Theme): UseStyles => ({
  Heading: {
    fontWeight: 500,
  },
});

export default Heading;
